import InViewAnimation from './InViewAnimation';

export default InViewAnimation;
